import React, {useEffect, useState} from 'react';
import {useLocation} from "react-router-dom";
import queryString from "query-string";
import * as mainActions from "../../../actions/actions";
import mainStore from "../../../stores/mainStore";

const VerifyEmail = () => {
  const { search } = useLocation();
  const [token, setToken] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    const values = queryString.parse(search);
    const tokenValue = values.token;
    
    if (tokenValue) {
      setToken(tokenValue);
      // Call verifyEmail action with token
      mainActions.verifyEmail({ token: tokenValue });
    } else {
      setError('Token is missing');
      setLoading(false);
    }
  }, [search]);
  
  useEffect(() => {
    const handleChange = () => {
      const successResponse = mainStore.state.verifyEmailResponse;
      const errorResponse = mainStore.state.verifyEmailError;
      
      // Handle error response first
      if (errorResponse) {
        setLoading(false);
        
        // Handle axios error response structure
        if (errorResponse.response && errorResponse.response.data) {
          const errorData = errorResponse.response.data;
          if (errorData.status === 'error') {
            setError(errorData.description || 'Verification failed');
            return;
          }
        }
        // Generic error if no structured error response
        setError('Verification failed. Please try again.');
        return;
      }
      
      // Handle success response
      if (successResponse) {
        setLoading(false);
        
        // Structure: {data: API_response, env_suffix: '...'}
        const { data: apiResponse, env_suffix } = successResponse;
        
        if (apiResponse) {
          // Check if API response has error status
          if (apiResponse.status === 'error') {
            setError(apiResponse.description || 'Verification failed');
            return;
          }
          
          // Check if API response has ok status with access_token and redirect_url
          if (apiResponse.status === 'ok' && apiResponse.data) {
            const { access_token, redirect_url } = apiResponse.data;
            
            if (access_token) {
              // Set cookie like in login.js
              mainStore.setCookie("tm-access-token", access_token, 1);
              
              // Handle redirect URL
              let redirectUrl = redirect_url;
              const values = queryString.parse(search);
              const queryRedirectUrl = values.redirectUrl;
              
              // Use redirect_url from response if available, otherwise check query params
              if (!redirectUrl && queryRedirectUrl) {
                redirectUrl = queryRedirectUrl;
              }
              
              // Validate and format redirect URL
              if (redirectUrl && redirectUrl.indexOf(window.location.hostname) === -1) {
                if (redirectUrl.indexOf("http://") === -1 && redirectUrl.indexOf("https://") === -1) {
                  redirectUrl = 'http://' + redirectUrl;
                }
              } else if (!redirectUrl) {
                // Default redirect like in login.js
                redirectUrl = `https://console${env_suffix || ''}.triplemars.com`;
              }
              
              console.log(`Redirecting to: ${redirectUrl}`);
              window.location = redirectUrl;
            } else {
              setError('Access token not found in response');
            }
          } else {
            setError('Invalid response format');
          }
        } else {
          setError('No data in response');
        }
      }
    };
    
    mainStore.on('changeVerifyEmail', handleChange);
    
    return () => {
      mainStore.removeListener('changeVerifyEmail', handleChange);
    };
  }, [search]);
  
  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '20px' }}>
        <p>Verifying your email...</p>
      </div>
    );
  }
  
  if (error) {
    return (
      <div style={{ textAlign: 'center', padding: '20px' }}>
        <p style={{ color: 'red' }}>{error}</p>
      </div>
    );
  }
  
  return null;
};

export default VerifyEmail;

